import { useSettingsStore } from '~/stores/settings'
import { pageUrl } from '~/helpers/urls'

const settings = useSettingsStore()

export const useMethodologyStore = defineStore('methodology', {
  state: () => ({
    title: '',
    footer_data: {},
    meta: {
      title: '',
      description: ''
    },
    og: {}
  }),
  actions: {
    async setMethodPage() {
      if (settings?.lang_id) {
        const params = {
          type: 'home.OurMethodologyPage',
          fields: '*',
          descendant_of: settings.lang_id,
        }
        try {
          const res = await useApiFetch(pageUrl, { params })
          const data = res.items[0]
          this.setData(data)
        } catch (err) {
          return err
        }
      }
    },
    setData(data) {
      this.title = data.title
      this.footer_data = data.content[data.content.length - 1].value
      this.meta.title = data.meta.seo_title || data.title
      this.meta.description = data.meta.search_description
      this.og = data.og
    },
  }
})

